
import { Property } from '../types';

/**
 * Normalizes an owner name to a consistent format for comparison.
 * Converts to uppercase and replaces spaces/hyphens with underscores.
 */
export const normalizeOwnerName = (name: string | undefined | null): string => {
  if (!name) return '';
  return String(name)
    .toUpperCase()
    .trim()
    .replace(/[- ]/g, '_');
};

/**
 * Identifies if a property belongs to or is managed in alliance with Habi.
 */
export const isHabiProperty = (property: Partial<Property> | null | undefined): boolean => {
  if (!property) return false;
  const matchHabi = (val?: string | null): boolean => {
    if (!val) return false;
    return val.toLowerCase().trim().includes('habi');
  };

  return (
    matchHabi(property.owner) ||
    matchHabi(property.estrategiaComercial) ||
    matchHabi((property as any).inmobiliaria) ||
    matchHabi((property as any).allied_broker)
  );
};

